import userSettingService from '../../../../../core/services/Common/UserSettingService';
import priceDataService from '../../../../../core/services/Prices/PriceData/PriceDataService';
import reducerRegistry from '../../../../helpers/ReducerRegistry';
import indexService from '../../../../../core/services/Market/MarketInDepth/IndexService';
import { isNotLogin } from '../../../../helpers/Common';
import Const from './Const';
import authProvider from '../../../../../core/AuthenticationProvider';

export const REDUCER_NAME = 'MAIN_LAYOUT:NOTIFI_MAQUEE';
export const UPDATE_HEADLINE_DATA = `${REDUCER_NAME}UPDATE_HEADLINE_DATA`;
export const ADD_HEADLINE_CODE = `${REDUCER_NAME}ADD_HEADLINE_CODE`;
export const FETCH_HEADLINE_CODE_SUCCESS = `${REDUCER_NAME}FETCH_HEADLINE_CODE_SUCCESS`;
export const REMOVE_HEADLINE_CODE = `${REDUCER_NAME}REMOVE_HEADLINE_CODE`;
export const SET_HEADLINE_DATA = `${REDUCER_NAME}SET_HEADLINE_DATA`;
export const SET_HEADLINE_CODE = `${REDUCER_NAME}SET_HEADLINE_CODE`;

const defaultHeadlineCodes = [
  { code: 'VNINDEX', displayCode: 'VNINDEX', isTicker: false },
  { code: 'HNXIndex', displayCode: 'HNXIndex', isTicker: false },
  { code: 'UpcomIndex', displayCode: 'UpcomIndex', isTicker: false },
  { code: 'VNXALL', displayCode: 'VNXALL', isTicker: false },
  { code: 'VN30', displayCode: 'VN30', isTicker: false },
  { code: 'HNX30', displayCode: 'HNX30', isTicker: false },
];

const initialState = {
  headlineData: {},
  headlineCodes: Const.guestHeadlineCodes,
};

export const setHeadlineCodes = codes => ({
  type: SET_HEADLINE_CODE,
  payload: codes,
});

export const fetchTickerData = ({ code, displayCode }) => {
  return priceDataService
    .getLatestPrice({
      Code: code,
    })
    .then(res => {
      if (!res.items || !Array.isArray(res.items) || !res.items[0].priceInfo) {
        return { [code]: { ticker: displayCode } };
      }

      return { [code]: res.items[0].priceInfo };
    });
};

export const addHeadlineCode = ({ organCode, ticker }) => async (
  dispatch,
  getState,
) => {
  const newCode = {
    code: organCode,
    displayCode: ticker,
    isTicker: true,
  };
  const headlineCodes = getState()[REDUCER_NAME].headlineCodes.concat(newCode);
  const user = getState().userInfo;
  if (!isNotLogin(user)) {
    userSettingService.updateUserSettings({
      MarqueeOrganCodes: JSON.stringify(headlineCodes),
    });
  }

  const tickerData = await fetchTickerData(newCode);

  dispatch({
    type: ADD_HEADLINE_CODE,
    payload: {
      data: tickerData,
      code: newCode,
    },
  });
};

export const removeHeadlineCode = code => (dispatch, getState) => {
  const headlineCodes = getState()[REDUCER_NAME].headlineCodes;
  const user = getState().userInfo;
  if (!isNotLogin(user)) {
    userSettingService.updateUserSettings({
      MarqueeOrganCodes: JSON.stringify(
        headlineCodes.filter(item => item.code !== code),
      ),
    });
  }
  dispatch({
    type: REMOVE_HEADLINE_CODE,
    payload: code,
  });
};

export const getTickerPromises = headlineCodes => {
  const promises = [];
  headlineCodes.forEach(item => {
    if (item.isTicker) {
      promises.push(fetchTickerData(item));
    }
  });

  return promises;
};

export const formatTickerData = tickerData => {
  return tickerData.reduce((data, item) => {
    return {
      ...data,
      ...item,
    };
  }, {});
};

export const fetchHeadlineData = () => async (dispatch, getState) => {
  const headlineCodes = getState()[REDUCER_NAME].headlineCodes;
  const [indicesData, ...tickerData] = await Promise.all([
    fetchIndicesData(headlineCodes),
    ...getTickerPromises(headlineCodes),
  ]);

  dispatch({
    type: SET_HEADLINE_DATA,
    payload: {
      ...indicesData,
      ...formatTickerData(tickerData),
    },
  });
};

export const fetchIndicesData = (
  headlineCodes,
  pageSize = 99999,
  status = 1,
) => {
  return indexService.getLatestIndices({ pageSize, status }).then(response => {
    const items = response.items || [];
    const data = {};
    items.forEach(item => {
      if (headlineCodes.some(code => code.code === item.comGroupCode)) {
        data[item.comGroupCode] = item;
      }
    });

    return data;
  });
};

export const subscribeRealtimeData = data => {
  return {
    type: UPDATE_HEADLINE_DATA,
    payload: {
      data,
    },
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_HEADLINE_DATA:
      return {
        ...state,
        headlineData: {
          ...state.headlineData,
          ...action.payload.data,
        },
      };
    case ADD_HEADLINE_CODE:
      return {
        ...state,
        headlineData: {
          ...state.headlineData,
          ...action.payload.data,
        },
        headlineCodes: state.headlineCodes.concat(action.payload.code),
      };
    case SET_HEADLINE_DATA:
      return {
        ...state,
        headlineData: action.payload,
      };
    case FETCH_HEADLINE_CODE_SUCCESS:
      const { codes, data } = action.payload;
      return {
        ...state,
        headlineCodes: [...new Set(state.headlineCodes.concat(codes))],
        headlineData: {
          ...state.headlineData,
          ...data,
        },
      };
    case REMOVE_HEADLINE_CODE:
      return {
        ...state,
        headlineCodes: state.headlineCodes.filter(
          item => item.code !== action.payload,
        ),
      };
    case SET_HEADLINE_CODE:
      return {
        ...state,
        headlineCodes: action.payload || defaultHeadlineCodes,
      };
    default:
      return state;
  }
};

reducerRegistry.register(REDUCER_NAME, reducer);
